<template>
  <Badge
    :color="badgeColor"
    :title="title"
    :size="large ? 'base' : 'xs'"
    pill
  />
</template>

<script lang="ts">
export type StatusBadgeClient = {
  status: string;
  inventory: {
    workflow: {
      statuses: WorkflowStatus[];
    };
  };
};
</script>

<script lang="ts" setup>
import { findIndex } from 'lodash';
import type { WorkflowStatus } from '@/types';
import { getStatusById } from '@/util/client-utils';

const props = defineProps({
  client: {
    type: Object as PropType<StatusBadgeClient>,
  },
  statusId: {
    type: String as PropType<WorkflowStatus['_id']>,
    default: undefined,
  },
  large: {
    type: Boolean,
    default: false,
  },
  statusName: {
    type: String,
  },
  statusIndex: {
    type: Number,
  },
  statusLength: {
    type: Number,
  },
});

const status = computed(() => {
  if (!props.client) {
    return;
  }
  return getStatusById(
    props.statusId ?? props.client.status,
    props.client.inventory.workflow
  );
});

const title = computed(() => {
  if (props.statusName) {
    return props.statusName;
  }

  return status.value?.name ?? '';
});
const index = computed(() => {
  if (typeof props.statusIndex !== 'undefined') {
    return props.statusIndex;
  }

  return findIndex(
    props.client?.inventory?.workflow?.statuses,
    (filteredStatus) => filteredStatus?._id === status.value?._id
  );
});

const badgeColor = computed(() => {
  const length =
    props.statusLength ??
    props.client?.inventory?.workflow?.statuses.length ??
    0;

  if (index.value === length - 1) {
    // Last status
    return 'green';
  }

  if (index.value === 0) {
    // First status
    return 'gray';
  }

  // In progress
  return 'indigo';
});
</script>
